import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import $ from 'jquery'
import purify from 'dompurify'
import { toastError } from "../utils/constants";
import { getCmsContent_action } from "../actions/cms_action/cmsAction";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footerData: []
    };
    this.loadscript()
  }

  loadscript() {
    $(document).ready(function () {
      $(this).scrollTop(0);
    });
  }
  componentDidMount() {
    if (Array.isArray(this.props.footerData) && this.props.footerData.length > 0) {
      this.setState({ footerData: this.props.footerData })
    } else {
      console.log('else header')
      this.getCmsContent(1, 'home');
    }
  }
  getCmsContent = async (MenuID, MenuUrl) => {
    const formattedMenuUrl = MenuUrl?.startsWith('/') ? MenuUrl.substring(1) : MenuUrl;
    try {
      this.setState({ isLoading: true });

      const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1, formattedMenuUrl ? formattedMenuUrl : 'home');
      if (data.error !== 1) {
        this.setState({
          isLoading: false,
          footerData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
        });
      } else {
        this.setState({ isLoading: false });
        toastError(data.msg);
      }
    } catch (err) {
      console.error(err);
      this.setState({ isLoading: false });
    }
  }
  onClickLoginSignUp() {
    localStorage.removeItem("award_event_profile_id")
    this.props.navigate('/signUp')
  }

  render() {
    const { footerData } = this.state;
    return (
      <>
        {(footerData && footerData.isActive) && (
          < div
            dangerouslySetInnerHTML={{
              __html: purify.sanitize(footerData?.FooterContent),
            }}
          />
        )}

        {/* <footer className="footer__area">
        <div className="container">
          <div className="footer__top">
            <div className="row">
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">ABOUT</h4>
                  <div className="footer__widget-link">
                    <ul className="list-wrap">
                      <li>
                        <a href="about-itme-2026.html">
                          <i className="renova-right-arrow" />
                          <span>About ITME 2026</span>
                        </a>
                      </li>
                      <li>
                        <a href="about-organizer.html">
                          <i className="renova-right-arrow" />
                          <span>About Organizer</span>
                        </a>
                      </li>
                      <li>
                        <a href="invitation-letter.html">
                          <i className="renova-right-arrow" />
                          <span>Invitation Letter</span>
                        </a>
                      </li>
                      <li>
                        <a href="Awards.html">
                          <i className="renova-right-arrow" />
                          <span>Awards</span>
                        </a>
                      </li>
                      <li>
                        <a href="daywise-itinerary.html">
                          <i className="renova-right-arrow" />
                          <span>Daywise Itinerary</span>
                        </a>
                      </li>
                      <li>
                        <a href="venue-details.html">
                          <i className="renova-right-arrow" />
                          <span>Venue Details</span>
                        </a>
                      </li>
                      <li>
                        <a href="at-a-glance-itme2026.html">
                          <i className="renova-right-arrow" />
                          <span>At a Glance ITME 2026</span>
                        </a>
                      </li>
                      <li>
                        <a href="associates-partners.html">
                          <i className="renova-right-arrow" />
                          <span>Associate/ Partners</span>
                        </a>
                      </li>
                      
                      <li>
                        <a href="industry-info.html">
                          <i className="renova-right-arrow" />
                          <span>Industry Info</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">FOR EXHIBITORS</h4>
                  <div className="footer__widget-link">
                    <ul className="list-wrap">
                      <li>
                        <a href="index-of-product.html">
                          <i className="renova-right-arrow" />
                          <span>Index Of Product</span>
                        </a>
                      </li>
                      <li>
                        <a href="venue-layout.html">
                          <i className="renova-right-arrow" />
                          <span>Venue Layout</span>
                        </a>
                      </li>
                    
                      <li>
                        <a href="exhibitors-list.html">
                          <i className="renova-right-arrow" />
                          <span>Exhibitor List 2022</span>
                        </a>
                      </li>
                      <li>
                        <a href="exhibitor-list-2026.html">
                          <i className="renova-right-arrow" />
                          <span>Exhibitor List 2026</span>
                        </a>
                      </li>
                     
                      <li>
                        <a href="past-events.html">
                          <i className="renova-right-arrow" />
                          <span>Past Events</span>
                        </a>
                      </li>
                      <li>
                        <a href="photo-gallery.html">
                          <i className="renova-right-arrow" />
                          <span>Past Events Gallery</span>
                        </a>
                      </li>
                      <li>
                        <a href="shuttle-bus-service.html">
                          <i className="renova-right-arrow" />
                          <span>Shuttle Bus Service</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">FOR VISITORS</h4>
                  <div className="footer__widget-link">
                    <ul className="list-wrap">
                      <li>
                        
                        <a
                          href="javascript:void(0)"
                          className="visitor_header_footer_click"
                        >
                          <i className="renova-right-arrow" />
                          <span>Visitor Registration</span>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)">
                          <i className="renova-right-arrow" />
                          <span>Visitor Travel Assistance</span>
                        </a>
                      </li>
                      <li>
                        <a href="photo-gallery.html">
                          <i className="renova-right-arrow" />
                          <span>Visitor Promotion</span>
                        </a>
                      </li>
                      
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">NEWS &amp; PR</h4>
                  <div className="footer__widget-link">
                    <ul className="list-wrap">
                      <li>
                        <a href="javascript:void(0);">
                          <i className="renova-right-arrow" />
                          <span>Photo Gallery</span>
                        </a>
                      </li>
                      <li>
                        <a href="video-gallery.html">
                          <i className="renova-right-arrow" />
                          <span>Video Gallery</span>
                        </a>
                      </li>
                      <li>
                        <a href="media-kit.html">
                          <i className="renova-right-arrow" />
                          <span>Media Kit</span>
                        </a>
                      </li>
                    
                    </ul>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
          <div className="footer_social_media_icons">
            <div className="separator">
              <ul>
                <li>
                  <a href="https://www.facebook.com/indiaitmesociety" target="_blank">
                    <i className="fab fa-facebook-f" />
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i className="fab fa-twitter" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/india-itme?trk=biz-companies-cym"
                    target="_blank"
                  >
                    <i className="fab fa-linkedin-in" />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/indiaitme/" target="_blank">
                    <i className="fab fa-instagram" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/c/IndiaITMESociety"
                    target="_blank"
                  >
                    <i className="fab fa-youtube" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="row align-items-center">
              <div className="col-md-12 text-center">
                <img src="assets/img/logo_2.png" />
                <div className="copyright-text">
                  <p>© 2026 India ITME All Rights Reserved.</p>
                </div>
              </div>
              <div className="col-md-12">
                <div className="footer__bottom-menu">
                  <ul className="list-wrap">
                    <li>
                      <a href="legal-stuff.html">Legal Stuff</a>
                    </li>
                    <li>
                      <a href="privacy-policy.html">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="cookie-policy.html">Cookie Policy</a>
                    </li>
                    <li>
                      <a href="terms-and-conditions.html">Terms &amp; Conditions</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer> */}

      </>
    );
  }
}
export default withRouter(
  connect(null, { getCmsContent_action })(Footer)
);